import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import { type FormEvent, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "@/components/pop-ui/pop-toast";
import { useORPC } from "@/providers/orpc-provider";
import { CodeInput, type CodeInputRef } from "../components/code-input";
import { Button, Input } from "../components/form-items";
import { type UserFormErrors, validateEmail } from "../utils";
interface ChangeEmailFormProps {
  // newEmail: string; // 新的邮箱地址 - 改为内部 state 管理
  area: string;
  onFinish?: () => void;
  initialEmail?: string; // 可选的初始邮箱值
  // currentPasswordRequired?: boolean; // 指示是否需要当前密码进行验证
}

// 更换绑定邮箱表单
export function ChangeEmailForm(t0) {
  const $ = _c(58);
  const {
    onFinish,
    initialEmail: t1
  } = t0;
  const initialEmail = t1 === undefined ? "" : t1;
  const [currentNewEmail, setCurrentNewEmail] = useState(initialEmail);
  const orpc = useORPC();
  const {
    t
  } = useTranslation();
  const [code, setCode] = useState("");
  const [showCodeInput, setShowCodeInput] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      email: "",
      password: "",
      code: ""
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [errors, setErrors] = useState(t2);
  const codeInputRef = useRef(null);
  let t3;
  if ($[1] !== orpc.user.changeEmailOtp) {
    t3 = orpc.user.changeEmailOtp.mutationOptions();
    $[1] = orpc.user.changeEmailOtp;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t) {
    t4 = () => {
      setShowCodeInput(true);
      setTimeout(() => {
        codeInputRef.current?.startCountdown();
      }, 500);
      toast.success(t("toast.success.verificationCodeSentToNewEmail"));
    };
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = {
      ...t3,
      onSuccess: t4,
      onError: _temp
    };
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    mutate: sendVerificationCode,
    isPending: isSendingCode
  } = useMutation(t5);
  let t6;
  if ($[8] !== orpc.user.changeEmail) {
    t6 = orpc.user.changeEmail.mutationOptions();
    $[8] = orpc.user.changeEmail;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onFinish || $[11] !== t) {
    t7 = () => {
      toast.success(t("toast.success.newEmailVerifiedBindingUpdated"));
      if (onFinish) {
        onFinish();
      }
    };
    $[10] = onFinish;
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = {
      ...t6,
      onSuccess: t7,
      onError: _temp2
    };
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const {
    mutate: changeEmail,
    isPending: isChanging
  } = useMutation(t8);
  let t9;
  if ($[16] !== currentNewEmail || $[17] !== sendVerificationCode || $[18] !== t) {
    t9 = async e => {
      e.preventDefault();
      setErrors({
        email: "",
        password: "",
        code: ""
      });
      if (!validateEmail(currentNewEmail)) {
        setErrors(prev => ({
          ...prev,
          email: t("error.invalidEmailAddress")
        }));
        return;
      }
      sendVerificationCode({
        email: currentNewEmail
      });
    };
    $[16] = currentNewEmail;
    $[17] = sendVerificationCode;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const handleSendCode = t9;
  let t10;
  if ($[20] !== changeEmail || $[21] !== code || $[22] !== currentNewEmail || $[23] !== t) {
    t10 = e_0 => {
      e_0.preventDefault();
      if (!code) {
        toast.error(t("toast.error.enterVerificationCode"));
        return;
      } else {
        if (code.length !== 6) {
          toast.error(t("toast.error.enter6DigitVerificationCode"));
          return;
        }
      }
      changeEmail({
        email: currentNewEmail,
        otp: code
      });
    };
    $[20] = changeEmail;
    $[21] = code;
    $[22] = currentNewEmail;
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const handleSubmitChange = t10;
  const isLoading = isSendingCode || isChanging;
  const t11 = showCodeInput ? handleSubmitChange : handleSendCode;
  let t12;
  if ($[25] !== t) {
    t12 = t("placeholder.newEmailAddress");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = e_1 => setCurrentNewEmail(e_1.target.value);
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = isLoading || showCodeInput;
  const t15 = showCodeInput ? "bg-gray-100" : "";
  let t16;
  if ($[28] !== currentNewEmail || $[29] !== t12 || $[30] !== t14 || $[31] !== t15) {
    t16 = <Input id="newEmail" placeholder={t12} value={currentNewEmail} onChange={t13} disabled={t14} className={t15} />;
    $[28] = currentNewEmail;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== errors.email) {
    t17 = errors.email && <p className="text-sm text-destructive leading-[1.5]">{errors.email}</p>;
    $[33] = errors.email;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t16 || $[36] !== t17) {
    t18 = <div className="space-y-2">{t16}{t17}</div>;
    $[35] = t16;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== code || $[39] !== currentNewEmail || $[40] !== errors.code || $[41] !== isLoading || $[42] !== sendVerificationCode || $[43] !== showCodeInput) {
    t19 = showCodeInput && <CodeInput ref={codeInputRef} value={code} onChange={setCode} onResend={() => sendVerificationCode({
      email: currentNewEmail
    })} error={errors.code} disabled={isLoading} autoStartCountdown={false} />;
    $[38] = code;
    $[39] = currentNewEmail;
    $[40] = errors.code;
    $[41] = isLoading;
    $[42] = sendVerificationCode;
    $[43] = showCodeInput;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== isChanging || $[46] !== isSendingCode || $[47] !== showCodeInput || $[48] !== t) {
    t20 = isSendingCode ? t("button.sending") : isChanging ? t("button.changing") : showCodeInput ? t("button.confirmChange") : t("button.sendCodeToNewEmail");
    $[45] = isChanging;
    $[46] = isSendingCode;
    $[47] = showCodeInput;
    $[48] = t;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== isLoading || $[51] !== t20) {
    t21 = <Button type="submit" className="w-full  " size="lg" loading={isLoading}>{t20}</Button>;
    $[50] = isLoading;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t11 || $[54] !== t18 || $[55] !== t19 || $[56] !== t21) {
    t22 = <form onSubmit={t11} className="space-y-3">{t18}{t19}{t21}</form>;
    $[53] = t11;
    $[54] = t18;
    $[55] = t19;
    $[56] = t21;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  return t22;
}
function _temp2() {}
function _temp() {}